import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container align-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "h3 m-4 text-center container" }, "Registeration Interface", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "row fw-bold m-2 justify-content-center container" }, "(Please Refresh page before entering data.)", -1)
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  class: "bi bi-arrow-repeat",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" }),
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"
  })
], -1)
const _hoisted_6 = { class: "row justify-content-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-1 text-right" }, " UserName ", -1)
const _hoisted_8 = { class: "col-6 col-sm-2 text-left" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row text-danger justify-content-center m-2" }, " (emails only) ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "row justify-content-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-3 col-sm-1 text-right" }, " Password ", -1)
const _hoisted_13 = { class: "col-6 col-sm-2 text-left" }
const _hoisted_14 = { class: "row justify-content-center" }
const _hoisted_15 = { class: "col-6 col-sm-3 m-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("form", {
  action: "?",
  method: "POST",
  class: "col-3 text-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { id: "validateNotRobot" }),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "row justify-content-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { class: "container" }
const _hoisted_21 = { class: "text-danger col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "col-4 col-sm-1 btn btn-primary m-4",
        title: "Refresh",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.reloadPage()))
      }, [
        _hoisted_5,
        _createTextVNode(" Refresh ")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.userName) = $event)),
          placeholder: "Enter Your Email Address"
        }, null, 512), [
          [_vModelText, $setup.userName]
        ])
      ])
    ]),
    _hoisted_9,
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.password) = $event)),
          placeholder: "Create Account Password"
        }, null, 512), [
          [_vModelText, $setup.password]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _withDirectives(_createElementVNode("div", _hoisted_15, _hoisted_17, 512), [
        [_vShow, $setup.isValidateNotRobotShown]
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _withDirectives(_createElementVNode("button", {
        class: _normalizeClass(["col-sm-1 col-4 btn btn-primary m-4", {'disabled':$setup.isBtnCreateUserLoginDisabled, 'btn-grey':$setup.isBtnCreateUserLoginDisabled}]),
        id: "btnCreateUserLogin",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.createUserLogin && $setup.createUserLogin(...args)))
      }, "Create User", 2), [
        [_vShow, $setup.isBtnCreateUserLoginShown]
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("span", _hoisted_21, _toDisplayString($setup.registrationStatus), 1)
    ])
  ]))
}